export const isOnMobile = function(data) {
    return data !== null && data !== undefined && data.indexOf('mobile') >= 0;
}

export const isOnDesktop = function(data) {
    return data !== null && data !== undefined && data.indexOf('desktop') >= 0;
}

export const isOnAny = function(data){
    return isOnDesktop(data) || isOnMobile(data);
}

export const getModeClasses = function(buttonsMode) {
    return {'mobile-hidden':!isOnMobile(buttonsMode), 'desktop-hidden':!isOnDesktop(buttonsMode)};
}